import React, { useState } from 'react';
import cn from 'classnames';
import Button from './button'

type CalendarProps = {
  onSelectDate?: (date: Date) => void;
  selectedDate?: Date;
  className?: string;
  show?: boolean;
}

const Calendar: React.FC<CalendarProps> = ({ onSelectDate, selectedDate: initialDate, className, show }) => {
  const [currentDate, setCurrentDate] = useState(initialDate || new Date());
  const [selectedDate, setSelectedDate] = useState(initialDate);

  const getDaysInMonth = (date: Date) => {
    return new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
  };

  const getFirstDayOfMonth = (date: Date) => {
    return new Date(date.getFullYear(), date.getMonth(), 1).getDay();
  };

  const months = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];

  const weekDays = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];

  const handlePrevMonth = () => {
    setCurrentDate(new Date(currentDate.getFullYear(), currentDate.getMonth() - 1));
  };

  const handleNextMonth = () => {
    setCurrentDate(new Date(currentDate.getFullYear(), currentDate.getMonth() + 1));
  };

  const handleDateSelect = (day: number) => {
    const newDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), day);
    setSelectedDate(newDate);
    onSelectDate?.(newDate);
  };

  const renderCalendar = () => {
    const daysInMonth = getDaysInMonth(currentDate);
    const firstDay = getFirstDayOfMonth(currentDate);
    const days = [];

    for (let i = 0; i < firstDay; i++) {
      days.push(<div key={`empty-${i}`} className="calendar-day empty"></div>);
    }

    for (let day = 1; day <= daysInMonth; day++) {
      const isSelected = selectedDate?.getDate() === day && 
                        selectedDate?.getMonth() === currentDate.getMonth() &&
                        selectedDate?.getFullYear() === currentDate.getFullYear();

      days.push(
        <div
          key={day}
          className={`calendar-day ${isSelected ? 'selected' : ''}`}
          onClick={() => handleDateSelect(day)}
        >
          {day}
        </div>
      );
    }

    return days;
  };

  return (
    <div className={cn('calendar', className, {
      'active': show
    })}>
      <div className="calendar-header">
        <div className="calendar-year">
          <h6>{currentDate.getFullYear()}</h6>
        </div>
        <div className="month-navigation">
          <Button variant='transparent' className="p-0" onClick={handlePrevMonth}>
            <svg width="11" height="19" viewBox="0 0 11 19" fill="none" xmlns="http://www.w3.org/2000/svg">
             <path d="M10 17.5L2 9.5L10 1.5" stroke="#2D2D2D" strokeWidth="1.5" strokeLinecap="round"/>
            </svg>
          </Button>
          <span>{months[currentDate.getMonth()]}</span>
          <Button variant='transparent' className="p-0" onClick={handleNextMonth}>
            <svg width="11" height="19" viewBox="0 0 11 19" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 17.5L9 9.5L1 1.5" stroke="#2D2D2D" strokeWidth="1.5" strokeLinecap="round"/>
            </svg>
          </Button>
        </div>
      </div>
      
      <div className="calendar-weekdays">
        {weekDays.map(day => (
          <div key={day} className="weekday">{day}</div>
        ))}
      </div>
      
      <div className="calendar-days">
        {renderCalendar()}
      </div>
    </div>
  );
};


export default Calendar;